import { render, staticRenderFns } from "./OverlayComponent.vue?vue&type=template&id=2c2e1f58&scoped=true"
import script from "./OverlayComponent.vue?vue&type=script&lang=js"
export * from "./OverlayComponent.vue?vue&type=script&lang=js"
import style0 from "./OverlayComponent.vue?vue&type=style&index=0&id=2c2e1f58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2e1f58",
  null
  
)

export default component.exports